import {common} from '@priority-software/priority-proto-api/lib';
import {initRecentItem, resetRecentItem} from '../../../_shared/GWTBridge/invoke/genPage';
import {getLang} from '../../../Localization';
import {getServerStoreData, setServerStoreData} from '../ServerStorage/service';
import {Action, getStorageKey, Namespace, StoreName, StoreProps} from '../ServerStorage/utils';

const keyParams: StoreProps = {
    nameSpace: Namespace.System,
    action: Action.Onload,
    storage: StoreName.RecentItems,
    lang: getLang(),
    hasWildcard: false
};

export const setRecentItem = async (value: Array<string>) => {
    /*
        Recent Items key will be saved as:
        System/Load/{language_ID}/RecentItems
        the value is an Array<string>
    */
    const key = getStorageKey(keyParams);
    const storeMap = {[key]: new common.Constant({Str: JSON.stringify(value)})};
    setServerStoreData(storeMap, true, false);
};

export const initLocalStorageRecentItems = async () => {
    const key = getStorageKey(keyParams);
    const res = await getServerStoreData([key], false, true);
    if (res[key]) {
        const recentItemsArr = JSON.parse(res[key]['Str']);
        recentItemsArr
            .slice()
            .reverse()
            .forEach((ri: string, index) => {
                // iterate in reverse because the function initRecentItem build an object of recentItems,
                // when we hit the last item it "render" the menue - notice in the function when key = 0
                initRecentItem(recentItemsArr.length - 1 - index, ri);
            });
    } else {
        resetRecentItem();
    }
};
